var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.658,
    height: 112.798,
    viewBox: "0 0 74.658 112.798",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M829.365,1102.567a37.4,37.4,0,0,0-37.324,37.324c-.237,22.562,11.456,39.215,23.857,56.7,4.134,5.668,8.267,11.693,12.163,18.07a1.358,1.358,0,0,0,1.3.709,1.631,1.631,0,0,0,1.3-.709c3.9-6.262,8.149-12.282,12.283-18.189,12.284-17.481,24.214-34.016,23.744-56.457a37.423,37.423,0,0,0-37.319-37.443Z",
    transform: "translate(-792.037 -1102.567)",
    fill: "#001233"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerActive);
export default __webpack_public_path__ + "static/media/markerActive.37651e7670b99d23100e70403a2b0ea8.svg";
export { ForwardRef as ReactComponent };